import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 3H1V21H23V3ZM4.99609 7.5H7V9.50391H4.99609V7.5ZM19 15V17H5V15H19ZM11 7.5V9.50391H8.99609V7.5H11ZM12.9961 7.5H15V9.50391H12.9961V7.5ZM19 7.5V9.50391H16.9961V7.5H19ZM4.99609 10.5H7V12.5039H4.99609V10.5ZM11 10.5V12.5039H8.99609V10.5H11ZM12.9961 10.5H15V12.5039H12.9961V10.5ZM19 10.5V12.5039H16.9961V10.5H19Z"}}]};

const KeyboardFilled = Vue.extend<IconProps>({
  name: 'KeyboardFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'keyboard-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default KeyboardFilled;
